"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _generalStore = require("general-store");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _SubjectDependency = _interopRequireDefault(require("crm_ui/flux/dependencies/SubjectDependency"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _UIAvatar = _interopRequireDefault(require("ui-addon-avatars/UIAvatar"));

var _StyledMiniProfileHighlight = require("crm_ui/profile/sidebar/highlight/mini/StyledMiniProfileHighlight");

var propTypes = {
  subject: _SubjectType.default
};

var MiniCompanyHighlight =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(MiniCompanyHighlight, _Component);

  function MiniCompanyHighlight() {
    (0, _classCallCheck2.default)(this, MiniCompanyHighlight);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MiniCompanyHighlight).apply(this, arguments));
  }

  (0, _createClass2.default)(MiniCompanyHighlight, [{
    key: "getDomainURL",
    value: function getDomainURL() {
      var subject = this.props.subject;
      var domain = (0, _ImmutableModel.getProperty)(subject, 'domain');

      if (!domain) {
        return null;
      }

      return domain.indexOf('http') === -1 ? "http://" + domain : String(domain);
    }
  }, {
    key: "renderAvatar",
    value: function renderAvatar() {
      var subject = this.props.subject;
      return _react.default.createElement("div", {
        className: "m-left-6 m-right-2 m-top-1"
      }, _react.default.createElement(_UIAvatar.default, {
        size: "sm",
        companyId: subject && (0, _ImmutableModel.getId)(subject),
        domain: (0, _ImmutableModel.getProperty)(subject, 'domain'),
        fileManagerKey: (0, _ImmutableModel.getProperty)(subject, 'hs_avatar_filemanager_key')
      }));
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var subject = this.props.subject;

      var title = (0, _ImmutableModel.getProperty)(subject, 'name') || _react.default.createElement(_FormattedMessage.default, {
        message: "companyHighlight.companyNamePlaceholder"
      });

      return _react.default.createElement(_StyledMiniProfileHighlight.StyledMiniProfileHighlightTitleTruncate, {
        hasSubtitle: !!this.getDomainURL()
      }, title);
    }
  }, {
    key: "renderSubtitle",
    value: function renderSubtitle() {
      var subject = this.props.subject;
      var domain = this.getDomainURL();

      if (!domain) {
        return null;
      }

      return _react.default.createElement(_UILink.default, {
        href: domain,
        external: true
      }, _react.default.createElement(_StyledMiniProfileHighlight.StyledMiniProfileHighlightSubtitle, null, (0, _ImmutableModel.getProperty)(subject, 'domain')));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_StyledMiniProfileHighlight.StyledMiniProfileHighlight, null, this.renderAvatar(), _react.default.createElement(_StyledMiniProfileHighlight.StyledMiniProfileHighlightDetails, {
        className: "text-left"
      }, this.renderTitle(), this.renderSubtitle()));
    }
  }]);
  return MiniCompanyHighlight;
}(_react.Component);

MiniCompanyHighlight.propTypes = propTypes;

var _default = (0, _generalStore.connect)({
  subject: _SubjectDependency.default
})(MiniCompanyHighlight);

exports.default = _default;
module.exports = exports.default;